module.exports = __webpack_public_path__ + "static/MAIN_SHOW_ACT_9_CHIME_PUSH_BNA_winner-e846040c81f6368ff69e83d189fdd79e.mp4";